import { render, staticRenderFns } from "./StudentArchive.vue?vue&type=template&id=4382987e&scoped=true"
import script from "./StudentArchive.vue?vue&type=script&lang=js"
export * from "./StudentArchive.vue?vue&type=script&lang=js"
import style0 from "./StudentArchive.vue?vue&type=style&index=0&id=4382987e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4382987e",
  null
  
)

export default component.exports